import styled from '@emotion/styled';

export const HideOnPrint = styled.div`
  @media print {
    display: none !important;
  }
`;
